import { FileDropzone } from "../../shared/components";

interface SplitCostingImportDropzoneProps {
  /** When true, the dropzone is disabled (company code not yet validated). */
  isDisabled?: boolean;
}

const SUB_INSTRUCTION =
  "CSV must contain: Employee Code, Apportioned Percentage, Division, Cost Centre, Department. " +
  "The file must not include an Employee Name column.";

/**
 * Dropzone placeholder shown in the layout before a company code is validated.
 * Mirrors `PayComponentImportDropzone` — same disabled-state UX pattern.
 */
export function SplitCostingImportDropzone({
  isDisabled = false,
}: SplitCostingImportDropzoneProps) {
  return (
    <FileDropzone
      value={null}
      onChange={() => {}}
      instruction="Drop your CSV file here, or click to browse"
      subInstruction={SUB_INSTRUCTION}
      accept=".csv"
      multiple={false}
      isDisabled={isDisabled}
      buttonText="Select CSV file"
      disabledButtonText="Enter a company code first"
      fileFilter={(file) => file.name.toLowerCase().endsWith(".csv")}
    />
  );
}
